import React, { useState } from 'react';
import {
  IconBuilding,//空间
  IconCircle,//默认
  IconCurrencyYen,//计费
  IconFolder, // 资产库
  IconKey,//密钥
  IconLayoutGrid,//应用
  IconSettings,//设置
  IconShieldCheck,//权限
  IconUsers,//用户
  IconBrandWechat,//微信
  IconAddressBook,//通讯录
  IconGift,//活动
  IconLibrary,//知识库
  IconPhotoSpark,//海报
  IconClipboardCheck, //问卷
  IconPresentation, //大屏
} from '@tabler/icons-react';

const iconMap: Record<string, React.ComponentType<{ className?: string; stroke?: number }>> = {
  IconBuilding, // 空间
  IconUsers, // 用户
  IconLayoutGrid, // 应用
  IconKey, // 密钥
  IconSettings, // 设置
  IconShieldCheck, // 权限
  IconCurrencyYen, // 计费
  IconBrandWechat, // 微信
  IconFolder, // 资产库
  IconAddressBook, // 通讯录
  IconGift, // 活动
  IconLibrary, // 知识库
  IconPhotoSpark, // 海报
  IconClipboardCheck, //问卷
  IconPresentation, //大屏
};

const DefaultIcon = IconCircle;
const iconStrokeWidth = 1.5;

/**
 * 应用图标：支持图标名称（从 iconMap 查找）或图片 URL
 * 与应用侧栏应用列表（HeroUI AppSidebar 内 SidebarAppsNav）中图标处理逻辑一致
 */
export function AppIcon({
  icon,
  className,
}: {
  icon: string | null | undefined;
  className?: string;
}) {
  const [imageError, setImageError] = useState(false);

  if (!icon) {
    return <DefaultIcon className={className} stroke={iconStrokeWidth} />;
  }

  if (
    (icon.startsWith('http://') || icon.startsWith('https://') || icon.startsWith('/')) &&
    !imageError
  ) {
    return (
      <img
        src={icon}
        alt=""
        className={className}
        onError={() => setImageError(true)}
      />
    );
  }

  const IconComponent = iconMap[icon];
  if (IconComponent) {
    return <IconComponent className={className} stroke={iconStrokeWidth} />;
  }

  return <DefaultIcon className={className} stroke={iconStrokeWidth} />;
}
